module.exports = __webpack_public_path__ + "img/sd.b8683777.png";